import { render } from "./TyreDetailPriceRow.vue?vue&type=template&id=e679c8ea"
import script from "./TyreDetailPriceRow.vue?vue&type=script&lang=js"
export * from "./TyreDetailPriceRow.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__